// extracted by mini-css-extract-plugin
module.exports = {"item-container":"program-details_item-container__XbpXP","item-card":"program-details_item-card__unnmm"};